import React from 'react';
import { Link } from 'react-router-dom';
import {
    Container,
    Box,
} from '@mui/material';
import "../../css/PaginaServicio/page.css"



export const SeccionPrecio = () => {
 

    return (
        <Box component="section" sx={{background:'#FFA457', height:'40vh', display:'flex', alignItems:'center', justifyContent:'center'}} >
            <Container maxWidth="lg" >
              <Box 
              sx={{
                display:'flex',
                alignItems:'center',
                justifyContent:'center',
                flexDirection:'column'
              }}
              className='informacionpageservicio'>
                <h3>Si buscas una solución vending innovadora y</h3>
                <h3>eficiente, HOD Vending es tu mejor aliado.</h3>
               </Box>

               <Box sx={{
                display:'flex',
                alignItems:'center',
                justifyContent:'center',
                flexDirection:'column'
              }}
              className='infobotonpageservicio'>
                <h4>Contáctanos y llevemos tu negocio al siguiente nivel</h4>
                 <Link to='/contacto' style={{ textDecoration: 'none', color: 'inherit' }}>
              <button className="buttondescripcioninfopageservicio"> Conoce más sobre nosotros</button>
              </Link>
               </Box>
            </Container>
        </Box>
    );
};
